// extracted by mini-css-extract-plugin
export default {"heading":"FormHeading_heading__Ybdqv"};